import { motion } from "framer-motion";
import { X, Check } from "lucide-react";

const pains = [
    "Excel-ark der hele tiden bliver overskrevet",
    "Glemte nøgler — ingen ved hvor de er",
    "Reklamationer falder mellem to stole",
    "Manglende kvalitets-dokumentation til kunden",
    "Papirsedler i bilerne — og halvdelen forsvinder",
    "Manuel fakturering tager hele fredagen",
    "Vikar tropper op — ingen ved hvilke nøgler at give",
    "Ingen overblik over hvem der er på job lige nu",
];

const gains = [
    "Live-overblik over alle ruter og opgaver",
    "Hver nøgle koblet til kunde + medarbejder",
    "Reklamationer sporet fra modtagelse til lukning",
    "Automatiske kvalitets-rapporter til kunden",
    "Mobil-first — alt direkte fra telefonen",
    "Fakturering med ét klik til e-conomic / Dinero",
    "Alt om kunden samlet ét sted — også for vikaren",
    "Realtids-dashboard: 84 medarbejdere på job lige nu",
];

export default function PainVsCleany() {
    return (
        <section className="py-24 md:py-32 bg-white" data-testid="pain-vs-cleany">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-3xl">
                    <div className="inline-flex items-center gap-2 rounded-full bg-rose-50 border border-rose-100 px-3 py-1 text-xs font-semibold text-rose-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-rose-500" /> Hverdagen i dag vs. med Cleany
                    </div>
                    <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                        Slut med papir, post-its <br className="hidden md:block" />
                        og glemte nøgler.
                    </h2>
                    <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
                        Cleany erstatter de 14 systemer og Excel-ark, der i dag holder driften
                        sammen. Ét sted. Mobil-first. Bygget til rengøringsbranchen.
                    </p>
                </div>

                <div className="mt-14 grid lg:grid-cols-2 gap-5">
                    {/* Pain column */}
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="rounded-2xl border-2 border-rose-200 bg-rose-50/40 p-7 relative overflow-hidden"
                        data-testid="pain-column"
                    >
                        <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-rose-200/40 blur-3xl" />
                        <div className="relative">
                            <div className="inline-flex items-center gap-2 rounded-full bg-rose-100 text-rose-700 px-3 py-1 text-[11px] font-bold uppercase tracking-wider">
                                I dag
                            </div>
                            <h3 className="mt-3 font-display text-xl font-semibold text-slate-900">
                                Sådan ser hverdagen ud uden Cleany
                            </h3>
                            <ul className="mt-5 space-y-3">
                                {pains.map((p, i) => (
                                    <li
                                        key={p}
                                        className="flex items-start gap-3 text-sm text-slate-700"
                                        data-testid={`pain-item-${i}`}
                                    >
                                        <span className="h-5 w-5 rounded-full bg-rose-100 border border-rose-200 inline-flex items-center justify-center shrink-0 mt-0.5">
                                            <X className="h-3 w-3 text-rose-600" strokeWidth={3} />
                                        </span>
                                        <span className="line-through decoration-rose-300 decoration-2 underline-offset-2">{p}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </motion.div>

                    {/* Gain column */}
                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="rounded-2xl border-2 border-emerald-200 bg-gradient-to-br from-emerald-50/60 via-white to-sky-50/40 p-7 relative overflow-hidden shadow-xl shadow-emerald-900/5"
                        data-testid="gain-column"
                    >
                        <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-emerald-200/40 blur-3xl" />
                        <div className="absolute -bottom-12 -left-12 h-40 w-40 rounded-full bg-sky-200/40 blur-3xl" />
                        <div className="relative">
                            <div className="inline-flex items-center gap-2 rounded-full bg-emerald-100 text-emerald-700 px-3 py-1 text-[11px] font-bold uppercase tracking-wider">
                                Med Cleany
                            </div>
                            <h3 className="mt-3 font-display text-xl font-semibold text-slate-900">
                                Sådan ser hverdagen ud med Cleany
                            </h3>
                            <ul className="mt-5 space-y-3">
                                {gains.map((g, i) => (
                                    <li
                                        key={g}
                                        className="flex items-start gap-3 text-sm text-slate-800 font-medium"
                                        data-testid={`gain-item-${i}`}
                                    >
                                        <span className="h-5 w-5 rounded-full bg-emerald-500 inline-flex items-center justify-center shrink-0 mt-0.5">
                                            <Check className="h-3 w-3 text-white" strokeWidth={3} />
                                        </span>
                                        <span>{g}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
